"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var b2c_theme_1 = require("../Theme/b2c-theme");
function getStateQuery(breakpoint, output) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function () {
        if (typeof breakpoint === 'boolean') {
            return breakpoint ? output : '';
        }
        if (Object.keys(b2c_theme_1.breakpoints).includes(breakpoint)) {
            return "@media (max-width: ".concat(b2c_theme_1.breakpoints[breakpoint], ") {\n          ").concat(output, "\n        }");
        }
        return "@media (max-width: ".concat(breakpoint, ") {\n        ").concat(output, "\n      }");
    });
}
exports.default = getStateQuery;
var templateObject_1;
//# sourceMappingURL=getStateQuery.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/utils/getStateQuery.js
// module id = 1532
// module chunks = 5 16 17 19 40